import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=487de6c2&scoped=true&"
import script from "./simple.ts?vue&type=script&lang=ts&"
export * from "./simple.ts?vue&type=script&lang=ts&"
import style0 from "./simple.vue?vue&type=style&index=0&id=487de6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487de6c2",
  null
  
)

export default component.exports